export function randomIdWithName(name: string) {
  return `${name}-${Math.trunc(Math.random() * 10 ** 10)}`;
}
